module.exports = __webpack_public_path__ + "static/media/GMA-S2100-4AER_OR01.e6bdaee1.png";